"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateSubTasksPlugin = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const core_1 = require("@material-ui/core");
const user_ui_1 = require("@sierralabs/user-ui");
const useFindWorkflows_1 = require("../../hooks/useFindWorkflows");
const TaskAssignDialog_1 = __importDefault(require("../../tasks/dialogs/TaskAssignDialog"));
const StyledConfiguratorDiv = styled_components_1.default.div `
  .field {
    margin: 12px 0;
  }
`;
const CreateSubTasksConfigurator = props => {
    var _a, _b;
    const { onChange } = props;
    const [invoke, setInvoke] = (0, react_1.useState)(props.invoke);
    const { workflowList, findWorkflows } = (0, useFindWorkflows_1.useFindWorkflows)();
    const data = (0, react_1.useMemo)(() => {
        const data = invoke.data
            ? Object.assign({}, invoke.data) : { numberOfTasks: 0 };
        // handle deprecated configuration
        if (data.workflowId) {
            data.workflow = { id: data.workflowId };
            delete data.workflowId;
        }
        if (Array.isArray(data.groupIds)) {
            data.groups = data.groupIds.map(id => ({ id }));
            delete data.groupIds;
        }
        return data;
    }, [invoke.data]);
    const updateData = (callback) => {
        const updatedInvoke = Object.assign(Object.assign({}, invoke), { data: callback(Object.assign({}, data)) });
        setInvoke(updatedInvoke);
        onChange === null || onChange === void 0 ? void 0 : onChange(updatedInvoke);
    };
    (0, react_1.useEffect)(() => {
        findWorkflows({ limit: 100 });
    }, [findWorkflows]);
    return (react_1.default.createElement(StyledConfiguratorDiv, null,
        react_1.default.createElement(core_1.TextField, { fullWidth: true, size: 'small', className: 'field', variant: 'outlined', label: 'Dialog Title', value: data.dialogTitle || '', onChange: event => {
                updateData(data => {
                    data.dialogTitle = event.target.value;
                    return data;
                });
            } }),
        react_1.default.createElement(core_1.TextField, { fullWidth: true, size: 'small', className: 'field', variant: 'outlined', label: 'Dialog Message', value: data.dialogMessage || '', onChange: event => {
                updateData(data => {
                    data.dialogMessage = event.target.value;
                    return data;
                });
            } }),
        workflowList && (react_1.default.createElement(core_1.TextField, { select: true, fullWidth: true, size: 'small', className: 'field', variant: 'outlined', label: 'SubTask Workflow', value: ((_a = data.workflow) === null || _a === void 0 ? void 0 : _a.id) || '', onChange: event => {
                const workflowId = parseInt(event.target.value);
                if (!workflowId)
                    return;
                const workflow = workflowList === null || workflowList === void 0 ? void 0 : workflowList.data.find(w => w.id === workflowId);
                if (!workflow) {
                    throw new Error('Workflow not found');
                }
                const { id, name } = workflow;
                updateData(data => {
                    data.workflow = { id, name };
                    return data;
                });
            } }, workflowList.data.map(workflowDto => (react_1.default.createElement(core_1.MenuItem, { key: workflowDto.id, value: workflowDto.id }, workflowDto.name))))),
        react_1.default.createElement(core_1.TextField, { select: true, fullWidth: true, size: 'small', className: 'field', variant: 'outlined', label: 'Number of SubTasks', value: data.numberOfTasks || '', onChange: event => {
                const parsed = parseInt(event.target.value);
                const value = isFinite(parsed) && parsed > -1 ? parsed : 0;
                updateData(data => {
                    data.numberOfTasks = value;
                    if (!data.groups) {
                        data.groups = [];
                    }
                    data.groups.length = value;
                    return data;
                });
            } }, Array.from(Array(10)).map((_, index) => (react_1.default.createElement(core_1.MenuItem, { key: index, value: index + 1 }, index + 1)))),
        Array.from(Array(((_b = invoke.data) === null || _b === void 0 ? void 0 : _b.numberOfTasks) || 0)).map((_, index) => {
            var _a, _b, _c;
            return (react_1.default.createElement(user_ui_1.GroupPicker, { key: index, value: (_c = (_b = (_a = invoke.data) === null || _a === void 0 ? void 0 : _a.groups) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.id, onChange: group => {
                    updateData(data => {
                        if (!data.groups) {
                            data.groups = [];
                        }
                        data.groups[index] = group
                            ? { id: group.id, name: group.name }
                            : null;
                        return data;
                    });
                } }));
        })));
};
const StyledDisplayDiv = styled_components_1.default.div `
  font-size: 13px;
  padding-left: 4px;
  text-indent: -4px;
  code {
    background: #f4f5fa;
    padding: 2px 5px;
    border-radius: 3px;
  }
  b {
    padding: 0 5px 0 0;
  }
`;
const CreateSubTasksDisplay = props => {
    var _a, _b, _c;
    const data = props.invoke.data;
    return (react_1.default.createElement(StyledDisplayDiv, null,
        react_1.default.createElement("div", { className: 'line' },
            react_1.default.createElement("code", null, "Sub Task Type"),
            react_1.default.createElement("b", null, "="),
            react_1.default.createElement("i", null, ((_a = data === null || data === void 0 ? void 0 : data.workflow) === null || _a === void 0 ? void 0 : _a.name) || `Workflow ID: ${data === null || data === void 0 ? void 0 : data.workflowId}`)),
        react_1.default.createElement("div", { className: 'line' },
            react_1.default.createElement("code", null, "Number of Sub Tasks"),
            react_1.default.createElement("b", null, "="),
            react_1.default.createElement("i", null, data === null || data === void 0 ? void 0 : data.numberOfTasks)), (_b = data === null || data === void 0 ? void 0 : data.groups) === null || _b === void 0 ? void 0 :
        _b.map((group, index) => (react_1.default.createElement("div", { key: index, className: 'line' },
            react_1.default.createElement("code", null, "Assign To"),
            react_1.default.createElement("b", null, "="),
            react_1.default.createElement("i", null, (group === null || group === void 0 ? void 0 : group.name) || `Group ID: ${group === null || group === void 0 ? void 0 : group.id}`)))), (_c = data === null || data === void 0 ? void 0 : data.groupIds) === null || _c === void 0 ? void 0 :
        _c.map(id => (react_1.default.createElement("div", { key: id, className: 'line' },
            react_1.default.createElement("code", null, "Assign To"),
            react_1.default.createElement("b", null, "="),
            react_1.default.createElement("i", null,
                "Group ID: ",
                id))))));
};
exports.CreateSubTasksPlugin = {
    src: 'createSubTasks',
    name: 'Create Sub Tasks',
    configurator: CreateSubTasksConfigurator,
    display: CreateSubTasksDisplay,
    validate: () => true,
    validateImport: () => {
        return {
            severity: 'warning',
            message: 'Contains SubTask information that might need to be' +
                ' updated when being imported to other environments.'
        };
    },
    service: (state, params, render) => {
        if (!render) {
            return false;
        }
        // get all unique groupIds
        const data = (Array.isArray(params) ? params : [params])[0].data;
        const allIds = [].concat(data.groupIds || [], (data.groups || []).filter(group => !!group).map(group => group.id));
        const groupIds = Array.from(new Set(allIds));
        return new Promise((resolve, reject) => {
            render(react_1.default.createElement(TaskAssignDialog_1.default, { open: true, multiple: true, groupIds: groupIds, taskId: state.context.task.id, title: (data === null || data === void 0 ? void 0 : data.dialogTitle) || 'Create Subtasks', message: (data === null || data === void 0 ? void 0 : data.dialogMessage) || 'Select users assigned to the subtasks.', onCancel: () => {
                    render(undefined);
                    reject();
                }, handleAssign: userIds => {
                    state.context.subTaskUserIds = userIds;
                    render(undefined);
                    resolve(true);
                } }));
        });
    }
};
//# sourceMappingURL=CreateSubTasksPlugin.js.map